export const startAction = (type) => `${type}:start`
export const successAction = (type) => `${type}:success`
export const failureAction = (type) => `${type}:failure`

export const ADD_ALERT = 'ADD_ALERT'
export const CLEAR_ALERTS = 'CLEAR_ALERTS'
